<template>
  <button
      ref="buttonRef"
      :type="type"
      class="btn"
      :disabled="disabled"
      :class="{disabled}"
      @click="onClick"
      @focus="onFocus"
  >
    <Spinner v-if="progress" />
    <slot v-else />
  </button>
</template>
<script setup>
import {hideAllPoppers} from "floating-vue";
import {ref} from "vue";
import Spinner from "@/js/Elements/Spinner.vue";

const emit = defineEmits(['click', 'focus']);
const props = defineProps({
  type: {
    type: String,
    default: 'button'
  },
  disabled: Boolean,
  progress: Boolean,
});
const buttonRef = ref();

function onClick(e) {
  if (props.type !== 'submit') {
    e.preventDefault();
  }

  emit('click', e);
}

function onFocus(e) {
  if (!buttonRef.value) return;
  const parent = buttonRef.value.closest('.v-popper__popper');
  if (!parent){
    hideAllPoppers();
  }
  emit('focus', e);
}
</script>